<template>
  <div class="max-h-[100%] h-[100%] overflow-auto dark:bg-dark-box-background" @scroll="handleInteractionsScroll">
    <div class="flex flex-col flex-1 w-full mb-[64px] bg-white rounded-xl rounded-t-none dark:bg-dark-box-background">
      <table
        v-if="!selected_email_or_meeting"
        :class="[interactions?.results?.length ? 'h-full' : '']"
        class="min-w-[98%] dark:bg-dark-box-background divide-light-divider-border dark:divide-dark-divider-border divide-y">
        <thead
          id="table-header"
          class="sticky top-0 z-10 w-full transition ease-in-out bg-light-box-background dark:bg-dark-box-background duration-side-menu-transition-duration">
          <draggable
            v-model="interaction_headers"
            :component-data="{
              type: 'transition-group',
              name: !drag ? 'flip-list' : null
            }"
            v-bind="{
              animation: 200,
              group: 'leads header',
              ghostClass: 'ghost',
              chosenClass: 'chosen'
            }"
            handle=".drag-handle"
            filter=".ignore-drag"
            item-key="id"
            class="text-left transition ease-in-out border-light-divider-border dark:border-dark-divider-border text-common-grey duration-side-menu-transition-duration"
            tag="tr"
            @start="drag = true"
            @end="updateInteractionsHeaders()">
            <template #item="{ element, index }">
              <th v-if="element.id == 'actions'" class="relative w-5 px-6 rounded-md ignore-drag non-draggable">
                <div />
              </th>
              <th
                v-else
                :class="{
                  '!rounded-tr-md': index == interaction_headers.length - 1,
                  '!bg-gray-300': element?.is_highlighted
                }"
                class="mr-20 font-semibold text-gray-500 bg-white whitespace-nowrap group/row"
                @click.stop="() => {}">
                <div class="flex justify-between w-full space-x-4">
                  <div
                    class="relative flex items-center w-full py-4"
                    @click.stop=""
                    @mouseout="$event.target.classList.remove('cursor-pointer', 'underline', 'text-blue')"
                    @mouseover="
                      ($event) => {
                        $event?.ctrlKey || $event?.altKey
                          ? $event.target.classList.add('cursor-pointer', 'underline', 'text-blue')
                          : $event.target.classList.remove('cursor-pointer', 'underline', 'text-blue')
                      }
                    ">
                    <button
                      class="absolute h-12 drag-handle w-[105%] text-gray-800 dark:hover:text-white cursor-move active:text-gray-500" />
                    <span class="relative ml-4 mr-4"> {{ $t(element.name) }}</span>
                  </div>

                  <Menu v-slot="{ close }" ref="goalsMenu" as="div" class="relative flex-shrink-0 ml-auto mr-4">
                    <MenuButton
                      :class="{
                        'bg-light-brand-blue': interaction_headers.find((x) => x.id == element.id && x?.value)
                      }"
                      class="inline-flex col-table-header-btn items-center justify-center w-10 -mt-[5%] h-[105%] bg-[#F8FAFB] border focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue"
                      @click="click_position = $utils.clone($store.state.ui.cursor_positions?.closest_side)">
                      <ListFilter v-if="interaction_headers.find((x) => x.id == element.id && x?.value)" color="white" />
                      <ChevronDown v-else class="w-12 h-12 py-4 text-common-grey" />
                    </MenuButton>
                    <transition
                      enter-active-class="transition duration-100 ease-out"
                      enter-from-class="transform scale-95 opacity-0"
                      enter-to-class="transform scale-100 opacity-100"
                      leave-active-class="transition duration-75 ease-in"
                      leave-from-class="transform scale-100 opacity-100"
                      leave-to-class="transform scale-95 opacity-0">
                      <MenuItems
                        class="absolute font-normal !z-50 w-60 mx-3 mt-0 -ml-28 origin-bottom-right bg-white shadow-lg rounded-lg focus:outline-none">
                        <div class="p-3 hover:bg-gray-100">
                          <Menu v-slot="{ close: closeFilterModal }" ref="goalsMenu" as="div" class="relative flex-shrink-0 ml-auto">
                            <MenuButton
                              class="inline-flex items-center justify-center focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue">
                              <ChevronDown
                                :class="[{ 'rotate-90': click_position == 'right' }, { '-rotate-90': click_position == 'left' }]"
                                class="w-4 h-4 ml-1 mr-5 text-common-grey" />
                              {{ $t("Filter column") }}
                            </MenuButton>
                            <MenuItems
                              :class="[{ '-ml-[307px]': click_position == 'right' }, { 'ml-[232px]': click_position == 'left' }]"
                              class="absolute z-50 mx-3 -mt-12 font-normal origin-bottom-right bg-white rounded-lg shadow-lg w-80 focus:outline-none">
                              <div class="mt-4 mb-4">
                                <span class="m-3">Filter {{ element.name }}</span>
                                <ChevronDown
                                  :class="[{ '-rotate-90': click_position == 'right' }, { 'rotate-90': click_position == 'left' }]"
                                  class="w-5 h-5 ml-auto mr-4 -mt-5 cursor-pointer text-common-grey"
                                  @click="closeFilterModal()" />
                              </div>
                              <ActivitiesColumnsFilter
                                :metric="element"
                                @change="
                                  ($event) => {
                                    if ($event?.value) {
                                      handleChangeColumnFilter($event)
                                      current_column_filter_valid = true
                                    } else {
                                      current_column_filter = null
                                      current_column_filter_valid = false
                                    }
                                  }
                                " />
                              <div class="flex items-center justify-center w-full mt-4 space-x-6">
                                <button
                                  class="-mt-3 text-sm text-light-brand-blue"
                                  @click="handleRemoveColumnFilter(element, closeFilterModal, close)">
                                  {{ $t("Clear filter") }}
                                </button>

                                <button
                                  :disabled="!current_column_filter_valid"
                                  class="mb-4 font-normal p-3 rounded-md text-white cursor-pointer bg-light-brand-blue w-44"
                                  @click="handleSubmitColumnFilter(closeFilterModal, close)">
                                  {{ $t("Show results") }}
                                </button>
                              </div>
                            </MenuItems>
                          </Menu>
                        </div>
                        <div
                          v-if="
                            element.id != 'tags' && element.id != 'companies' && element.id != 'contacts' && element.id != 'collaborators'
                          "
                          class="p-3 flex space-x-2 items center hover:bg-[#F8FAFB] cursor-pointer"
                          @click.stop="
                            () => {
                              element.sort_index =
                                element?.sort == 0 || element?.sort == undefined
                                  ? interaction_headers.filter((x) => x.sort != 0).length
                                  : element.sort_index
                              element.sort = element.sort == 1 ? 0 : ~-element.sort ^ element.sort
                              sortRecords()
                            }
                          ">
                          <ChevronDown v-if="element.sort == -1" class="w-5 h-5 mr-3 text-common-grey" aria-hidden="true" />
                          <ChevronUp v-else-if="element.sort == 1" class="w-5 h-5 mr-3 text-common-grey" aria-hidden="true" />
                          <ChevronsUpDown v-else class="w-5 h-5 mr-3 text-common-grey" aria-hidden="true" />

                          <span class="">{{ $t("Sort column") }}</span>
                        </div>
                      </MenuItems>
                    </transition>
                  </Menu>
                </div>
              </th>
            </template>
          </draggable>
        </thead>
        <tbody
          v-if="interactions?.results?.length"
          class="bg-white dark:bg-dark-box-background divide-light-divider-border dark:divide-dark-divider-border divide-y-[2px]">
          <tr
            v-for="interaction in interactions?.results"
            :key="interaction.id"
            as="div"
            class="w-full h-16 py-0 hover:bg-gray-100 dark:hover:bg-gray-600 hover:cursor-pointer"
            @click.stop="openDetails(interaction)">
            <template v-for="header in interaction_headers" :key="header.id + interaction.id">
              <td v-if="header.id == 'actions'" class="px-2 py-0 w-[28px] whitespace-nowrap text-sm text-gray-500">
                <div class="relative flex items-center">
                  <div @click.stop="">
                    <Menu v-if="!editing_disabled" as="div" class="flex-shrink-0 ml-auto">
                      <MenuButton
                        class="inline-flex items-center justify-center text-gray-400 transition ease-in-out rounded duration-side-menu-transition-duration"
                        @click.stop="">
                        <span class="sr-only">{{ $t("Open options") }}</span>
                        <EllipsisVertical :color="$store.state.ui.darkMode ? '#fff' : ''" class="w-5 h-5 border-none" />
                      </MenuButton>
                      <transition
                        enter-active-class="transition duration-100 ease-out"
                        enter-from-class="transform scale-95 opacity-0"
                        enter-to-class="transform scale-100 opacity-100"
                        leave-active-class="transition duration-75 ease-in"
                        leave-from-class="transform scale-100 opacity-100"
                        leave-to-class="transform scale-95 opacity-0">
                        <MenuItems
                          class="absolute left-0 z-30 flex flex-col items-start content-center justify-center p-2 mx-3 mt-1 origin-top-right bg-white rounded-md shadow-lg outline-none dark:bg-dark-screen-background ring-1 ring-black ring-opacity-5 focus:outline-none">
                          <MenuItem
                            v-if="interaction.record"
                            v-slot="{ active }"
                            @click.prevent="
                              () => {
                                $utils.Record(interaction.record).open()
                              }
                            ">
                            <div
                              :class="[
                                active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                                'group flex items-center px-3 py-2 text-sm'
                              ]">
                              <Link color="#899399" class="w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                              <span>{{ $t("Visit") }} {{ $utils.getRecordName(interaction.record) }}</span>
                            </div>
                          </MenuItem>
                          <MenuItem
                            v-slot="{ active }"
                            @click.prevent="
                              () => {
                                $emitter.emit('updateInteraction', {
                                  interaction: $utils.clone(interaction)
                                })
                              }
                            ">
                            <div
                              :class="[
                                active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                                'group flex items-center px-3 py-2 text-sm'
                              ]">
                              <Pencil color="#899399" class="w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                              <span>{{ $t("Update Interaction") }}</span>
                            </div>
                          </MenuItem>
                          <MenuItem
                            v-slot="{ active }"
                            @click.prevent="
                              () => {
                                $emitter.emit('updateInteraction', {
                                  interaction: $utils.clone(interaction),
                                  is_template: true
                                })
                              }
                            ">
                            <div
                              :class="[
                                active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                                'group flex items-center px-3 py-2 text-sm'
                              ]">
                              <LayoutPanelTop
                                color="#899399"
                                class="w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500"
                                aria-hidden="true" />
                              <span>{{ $t("Use as Template") }}</span>
                            </div>
                          </MenuItem>
                          <MenuItem
                            v-slot="{ active }"
                            @click.prevent="
                              () => {
                                $emitter.emit(ALL_EMITTERS.DELETE_OBJECT, {
                                  object: {
                                    ...interaction,
                                    type: 'Interaction'
                                  },
                                  objectDeleteCallBack: () => {
                                    $emit('cancel')
                                  }
                                })
                              }
                            ">
                            <div
                              :class="[
                                active ? 'text-gray-900 dark:text-dark-body-text' : 'text-gray-600 dark:text-dark-body-text',
                                'group flex items-center px-3 py-2 text-sm'
                              ]">
                              <Trash2 class="w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                              <span>{{ $t("Delete Interaction") }}</span>
                            </div>
                          </MenuItem>
                        </MenuItems>
                      </transition>
                    </Menu>
                  </div>
                </div>
              </td>
              <td
                v-if="header.id == 'type'"
                class="px-2 text-sm font-bold capitalize whitespace-nowrap text-light-body dark:text-dark-body-text">
                <div class="flex items-center">
                  <div v-if="interaction.type == 'call'">
                    <Phone class="w-4 h-4 mr-2 text-common-grey" />
                  </div>
                  <div v-else-if="interaction.type == 'email'" class="flex">
                    <div
                      v-if="!interaction.email_opened && (interaction.source == 'gmail' || interaction.source == 'outlook')"
                      class="w-3 h-3 mt-2 mr-1 rounded-full bg-gradient-to-r from-status-success-green to-green-400" />
                    <Reply v-if="interaction.meta_data.is_sent" class="w-4 h-4 mt-1 rotate-180" />
                    <GmailIcon v-if="interaction.origin == 'gmail'" class="w-8 h-8 mr-2" />
                    <OutlookIcon v-else-if="interaction.origin == 'outlook'" class="w-8 h-8 mr-2" />
                    <Mail
                      v-else-if="interaction.origin != 'gmail' || interaction.origin != 'outlook'"
                      class="w-4 h-4 mr-2 text-common-grey" />
                  </div>
                  <div v-else-if="interaction.type == 'note'">
                    <StickyNote class="w-4 h-4 mr-2 text-common-grey" />
                  </div>
                  <div v-else-if="interaction.type == 'whatsapp'">
                    <WhatsappIcon class="w-4 h-4 mr-2 text-common-grey" />
                  </div>
                  <div v-else-if="interaction.type == 'marketing'">
                    <Megaphone class="w-4 h-4 mr-2 text-common-grey" />
                  </div>
                  <div v-else-if="interaction.type == 'meeting'">
                    <GoogleIcon v-if="interaction.origin == 'gmail'" class="w-6 h-6 mr-2" />
                    <MicrosoftIcon v-else-if="interaction.origin == 'outlook'" class="w-6 h-6 mr-2" />
                    <UsersRound
                      v-else-if="interaction.origin != 'gmail' || interaction.origin != 'outlook'"
                      color="#899399"
                      class="w-4 h-4 mr-2 text-common-grey" />
                    <div
                      v-if="
                        interaction.type == 'meeting' &&
                          (interaction.origin == 'gmail' || interaction.origin == 'outlook') &&
                          !interaction.meta_data?.conferencing
                      "
                      class="absolute hidden text-xs italic font-normal lowercase whitespace-nowrap">
                      {{ $t("creation in progress...") }}
                    </div>
                  </div>
                  <div v-else-if="interaction.type == 'support'">
                    <Wrench class="w-4 h-4 mr-2 text-common-grey" />
                  </div>
                  <p v-if="interaction.origin != 'gmail' && interaction.origin != 'outlook' && interaction?.type" class="capitalize">
                    {{ interaction?.type }}
                  </p>
                  <div v-if="interaction.origin == 'gmail' || interaction.origin == 'outlook'" :class="['whitespace-nowrap relative']">
                    <div :class="['font-medium  has-tooltip', { 'font-extrabold': calculateUnread(interaction) }]">
                      {{ interaction?.name?.length > 28 ? interaction?.name.slice(0, 27) + "..." : interaction?.name }}

                      <span
                        class="inline-flex items-center gap-2 px-2 py-1 font-medium rounded-md tooltip whitespace-nowrap text-md bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                        {{ interaction.name }}</span>
                      <span v-if="interaction.children?.length" class="ml-1 text-sm font-light">{{ interaction.children.length }}</span>
                    </div>
                  </div>
                  <div class="relative flex gap-1 ml-1">
                    <Badge :icon="task_icon" :object="interaction" :list-name="'tasks'" />
                  </div>
                </div>
              </td>
              <td
                v-else-if="header.id == 'tags'"
                class="items-center min-w-[150px] px-2 dark:text-dark-body-text whitespace-nowrap text-sm font-medium text-gray-900">
                <div v-if="interaction?.tags?.length" class="flex flex-row gap-1 flex-nowrap">
                  <div
                    v-for="tag in interaction?.is_all_assigned_tags_shown ? interaction?.tags : interaction?.tags?.slice(0, 2)"
                    :key="tag"
                    class="flex justify-between px-2 py-2 pl-3 text-left rounded-lg dark:text-dark-body-text focus:outline-none"
                    :style="{
                      background: `${all_tags.find((t) => t.id == tag)?.color}0F`
                    }">
                    <span class="flex items-center mr-1">
                      <span
                        class="mr-2 w-3.5 h-3.5 rounded-full"
                        :style="{
                          background: all_tags.find((t) => t.id == tag)?.color
                        }" />
                      <span
                        class="block font-bold truncate"
                        :style="{
                          color: all_tags.find((t) => t.id == tag)?.color
                        }">{{ all_tags.find((t) => t.id == tag)?.name }}</span>
                    </span>
                  </div>
                  <div
                    v-if="interaction?.tags?.length > 2 && !interaction?.is_all_assigned_tags_shown"
                    class="flex items-center flex-none mr-1 font-normal group/tags flex-nowrap dark:text-white">
                    <span class="block group-hover/tags:hidden">+{{ interaction?.tags?.length - 2 }} {{ $t("more") }}</span>
                    <div class="relative" @click.stop="showAllAssignedTags(interaction)">
                      <transition
                        class="hidden group-hover/tags:block"
                        mode="out-in"
                        enter-active-class="animate__animated animate__fadeIn"
                        leave-active-class="animate__animated animate__fadeOut"
                        duration="100">
                        <button
                          class="z-30 flex items-center justify-center w-7 h-7 p-1.5 ml-2 transition-all border rounded-md opacity-0 group-hover/tags:delay-300 group-hover/tags:duration-300 group-hover/tags:opacity-100 group-hover/tags:scale-125 group-hover/tags:bg-gray-200">
                          <ArrowLeftFromLine
                            class="absolute inset-0 w-5 h-5 m-auto text-white"
                            :class="[$store.state.portfolio.ui_options?.language == 'ar' ? '' : 'rotate-180']" />
                        </button>
                      </transition>
                    </div>
                  </div>
                  <div
                    v-else-if="interaction?.tags?.length > 2 && interaction?.is_all_assigned_tags_shown"
                    class="flex items-center flex-none mr-1 font-normal flex-nowrap dark:text-white"
                    @click.stop="showAllAssignedTags(interaction)">
                    <div class="relative">
                      <transition
                        mode="out-in"
                        enter-active-class="animate__animated animate__fadeIn"
                        leave-active-class="animate__animated animate__fadeOut"
                        duration="100">
                        <button
                          class="z-30 hover:scale-125 flex items-center justify-center w-7 h-7 p-1.5 transition-all duration-300 delay-300 hover:bg-gray-200 border rounded-md">
                          <ArrowLeftFromLine
                            class="absolute inset-0 w-5 h-5 m-auto"
                            :class="[$store.state.portfolio.ui_options?.language == 'ar' ? 'rotate-180' : '']" />
                        </button>
                      </transition>
                    </div>
                  </div>
                </div>
                <div v-else class="flex flex-row items-center flex-none gap-1 pl-2 flex-nowrap">
                  -
                </div>
              </td>
              <td
                v-if="header.id == 'category' && interaction.category"
                class="px-10 text-sm truncate text-light-body dark:text-dark-body-text">
                <p v-if="interaction.category == 'qbr' || interaction.category == 'ebr'">
                  {{ interaction?.category.toUpperCase() }}
                </p>
                <p v-else>
                  {{ interaction?.category[0].toUpperCase() }}{{ interaction.category.slice(1).replace("_", " ") }}
                </p>
              </td>
              <td v-else-if="header.id == 'category' && !interaction.category" class="px-6 text-sm text-gray-700">
                <p>{{ " - " }}</p>
              </td>
              <td
                v-if="header.id == 'companies'"
                class="px-4 text-sm text-light-body dark:text-dark-body-text whitespace-nowrap group/notes">
                <div class="flex items-center justify-start" @click.stop>
                  <Menu v-if="!editing_disabled" as="div" class="flex-shrink-0">
                    <MenuButton
                      class="inline-flex items-start justify-start rounded-full border-1 focus:outline-none focus:ring-1 focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue">
                      <div class="flex-shrink-0">
                        <img
                          onerror="this.style.display='none'"
                          class="inline-block rounded-full h-9 w-9 object-cover"
                          :src="`https://logosnap.io/api/${$utils.getDomainName(
                            interaction?.record?.values[$utils.getOptionMetricReference('company', 'website')]
                          )}?token=ecoTB81m5dQqkrjw`"
                          alt="">
                      </div>
                      <div class="ml-3 text-start has-tooltip">
                        <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                          <span class="flex truncate flex-nowrap whitespace-nowrap overflow-ellipsis">{{
                            Record.from(interaction?.record)?.name
                          }}</span>
                        </p>
                        <p class="text-xs font-medium dark:!text-gray-300 text-gray-600 group-hover:text-gray-900 capitalize">
                          {{ interaction?.record?.type }}
                        </p>
                        <span
                          class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                          {{ Record.from(interaction?.record).name }}
                        </span>
                      </div>
                    </MenuButton>
                    <transition
                      enter-active-class="transition duration-100 ease-out"
                      enter-from-class="transform scale-95 opacity-0"
                      enter-to-class="transform scale-100 opacity-100"
                      leave-active-class="transition duration-75 ease-in"
                      leave-from-class="transform scale-100 opacity-100"
                      leave-to-class="transform scale-95 opacity-0">
                      <MenuItems
                        :style="{
                          marginTop: `${interactions_top_scroll * -1}px`
                        }"
                        as="ul"
                        class="absolute z-50 mx-3 mt-3 -ml-10 origin-bottom-right bg-white border rounded-md shadow-sm focus:outline-none">
                        <MenuItem v-for="item in getRecordActions(interaction.record)" :key="item.name" v-slot="{ active }" as="li">
                          <div v-if="item?.divider" class="divide-y divide-gray-100" />
                          <button
                            v-else
                            :disabled="item.disabled"
                            :class="[
                              active
                                ? 'bg-light-brand-blue dark:bg-dark-brand-blue text-dark-body-text'
                                : 'text-light-body-text dark:text-dark-body-text',
                              'w-full group sm:text-sm flex items-center px-4 py-2  disabled:dark:bg-dark-transparent-brand-blue disabled:cursor-default disabled:opacity-60 transition ease-in-out duration-side-menu-transition-duration'
                            ]"
                            @click="item.action">
                            <component
                              :is="item.icon"
                              v-if="item.icon"
                              :class="active ? 'text-dark-body-text' : 'text-common-grey'"
                              class="w-5 h-5 mr-3 transition ease-in-out duration-side-menu-transition-duration"
                              aria-hidden="true" />
                            <p>
                              {{ item.name?.length > 18 ? item.name.slice(0, 17) + "..." : item.name }}
                            </p>
                          </button>
                        </MenuItem>
                      </MenuItems>
                    </transition>
                  </Menu>
                  <div class="relative ml-1 -mt-4" @click.stop="openModalNotes(interaction?.record)">
                    <NotesIcon
                      :class="[
                        interaction?.record?.notes_summary?.count == 0 || interaction?.record?.notes?.length == 0
                          ? 'opacity-0'
                          : 'opacity-100',
                        'group-hover/notes:opacity-100 mr-2 w-5 h-5'
                      ]" />
                    <div class="flex justify-center items-center absolute left-0.5 top-0">
                      <div class="flex items-center justify-center w-4 h-4 text-xs font-bold text-center text-white rounded-full">
                        <Plus
                          v-if="interaction?.record?.notes_summary?.count == 0 || interaction?.record?.notes?.length == 0"
                          class="w-5 h-5 text-white transition opacity-0 group-hover/notes:opacity-100" />
                        <div v-else>
                          {{ interaction?.record?.notes_summary?.count || interaction?.record?.notes.length }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td v-if="header.id == 'contacts'" class="relative px-6 text-sm text-gray-500 whitespace-nowrap">
                <div v-if="interaction.contacts?.length == 1">
                  <div class="flex items-center">
                    <div class="relative flex-shrink-0">
                      <img
                        v-if="interaction.contacts[0].avatar"
                        class="inline-block rounded-full h-9 w-9 object-cover"
                        :src="$utils.extractUrl(interaction.contacts[0].avatar)"
                        alt="">
                      <Avatar
                        v-else
                        :first-name="Record.from(interaction.contacts[0]).first_name"
                        :last-name="Record.from(interaction.contacts[0]).last_name" />

                      <div
                        v-if="interaction.contacts[0].origin == 'gmail' || interaction.contacts[0].origin == 'outlook'"
                        class="absolute w-5 h-5 p-2 ml-3 -mt-4 bg-white rounded-full" />
                      <GoogleIcon v-if="interaction.contacts[0].origin == 'gmail'" class="absolute ml-3.5 w-4 h-4 -mt-3.5" />
                      <MicrosoftIcon v-else-if="interaction.contacts[0].origin == 'outlook'" class="absolute w-3 h-3 ml-4 -mt-3" />
                    </div>
                    <div class="ml-3">
                      <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                        {{ Record.from(interaction.contacts[0]).full_name }}
                      </p>
                      <!-- <p class="text-xs font-medium text-gray-500 group-hover:text-gray-700">View profile</p> -->
                    </div>
                  </div>
                </div>
                <div v-else-if="interaction.contacts?.length > 1">
                  <div class="flex items-center -space-x-4 overflow-hidden">
                    <span v-for="user in interaction.contacts.slice(0, 4)" :key="user.id" class="flex-shrink-0 inline-block has-tooltip">
                      <img
                        v-if="user.avatar"
                        class="inline-block rounded-full h-9 w-9 object-cover"
                        :src="$utils.extractUrl(user.avatar)"
                        alt="">
                      <Avatar v-else :first-name="Record.from(user).first_name" :last-name="Record.from(user).last_name" />
                      <div
                        v-if="user.origin == 'gmail' || user.origin == 'outlook'"
                        class="absolute w-5 h-5 p-2 ml-3 -mt-4 bg-white rounded-full" />
                      <GoogleIcon v-if="user.origin == 'gmail'" class="absolute ml-3.5 w-4 h-4 -mt-3.5" />
                      <MicrosoftIcon v-else-if="user.origin == 'outlook'" class="absolute w-3 h-3 ml-4 -mt-3" />
                      <span class="p-1 bg-gray-300 rounded-sm tooltip whitespace-nowrap">
                        <div class="">
                          <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                            {{
                              (Record.from(user).first_name == null ? "" : Record.from(user).first_name) +
                                " " +
                                (Record.from(user).last_name == null ? "" : Record.from(user).last_name)
                            }}
                          </p>
                          <!-- <a class="text-xs font-medium text-gray-500 cursor-pointer group-hover:text-gray-700">View profile</a> -->
                        </div>
                      </span>
                    </span>
                    <span
                      v-if="interaction.contacts?.length > 4"
                      class="relative ml-auto text-sm left-6 text-light-brand-blue dark:text-dark-brand-blue">
                      + {{ interaction.contacts?.length - 4 }} {{ $t("more") }}</span>
                  </div>
                </div>
                <div v-else>
                  <span class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium capitalize rounded-xl dark:text-dark-body-text">
                    <span
                      class="inline-flex items-center flex-shrink-0 gap-2 px-2 py-1 text-sm font-medium capitalize rounded-xl dark:text-dark-body-text"
                      @click.stop>
                      <div class="absolute flex w-full bottom-4 -right-2">
                        <ContactsSelect
                          :disabled="editing_disabled"
                          :companies="[interaction.record]"
                          label=""
                          @update:selected-contacts="
                            ($event) => {
                              handleInteractionSetContactsList($event, interaction)
                            }
                          " />
                      </div>
                    </span>
                  </span>
                </div>
              </td>
              <td
                v-if="header.id == 'collaborators'"
                class="px-6 text-sm text-gray-500 text-light-body dark:text-dark-body-text whitespace-nowrap">
                <div v-if="interaction.users?.length == 1">
                  <div class="flex items-center">
                    <div class="flex-shrink-0">
                      <img
                        v-if="$store.state.data.users.find((u) => u.id == interaction.users[0])?.avatar"
                        class="inline-block w-8 h-8 rounded-full"
                        :src="$store.state.data.users.find((u) => u.id == interaction.users[0])?.avatar"
                        alt="">
                      <Avatar
                        v-else
                        :first-name="$store.state.data.users.find((u) => u.id == interaction.users[0])?.first_name"
                        :last-name="$store.state.data.users.find((u) => u.id == interaction.users[0])?.last_name" />
                    </div>
                    <div class="ml-3">
                      <p class="text-sm font-medium text-gray-700 dark:text-white group-hover:text-gray-900">
                        {{ Record.from($store.state.data.users.find((u) => u.id == interaction.users[0]))?.full_name }}
                      </p>
                      <!-- <p class="text-xs font-medium text-gray-500 group-hover:text-gray-700">View profile</p> -->
                    </div>
                  </div>
                </div>
                <div v-else-if="interaction.users?.length > 1">
                  <div class="flex items-center -space-x-4 overflow-hidden">
                    <span v-for="user in interaction.users.slice(0, 4)" :key="user.id" class="flex-shrink-0 inline-block has-tooltip">
                      <img
                        v-if="$store.state.data.users.find((u) => u.id == user)?.avatar"
                        class="inline-block rounded-full shadow-sm h-9 w-9"
                        :src="$store.state.data.users.find((u) => u.id == user)?.avatar"
                        alt="">
                      <Avatar
                        v-else
                        :first-name="Record.from($store.state.data.users.find((u) => u.id == user))?.full_name"
                        :last-name="Record.from($store.state.data.users.find((u) => u.id == user))?.full_name" />
                      <span class="p-1 bg-gray-300 rounded-sm tooltip whitespace-nowrap">
                        <div class="">
                          <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                            {{ Record.from($store.state.data.users.find((u) => u.id == user))?.full_name }}
                          </p>
                          <!-- <a class="text-xs font-medium text-gray-500 cursor-pointer group-hover:text-gray-700">View profile</a> -->
                        </div>
                      </span>
                    </span>
                    <span
                      v-if="interaction.users?.length > 4"
                      class="relative ml-auto text-sm left-6 text-light-brand-blue dark:text-dark-brand-blue">
                      + {{ interaction.users?.length - 4 }} {{ $t("more") }}</span>
                  </div>
                </div>
                <div v-else class="mt-6">
                  <span class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium capitalize rounded-xl dark:text-dark-body-text">
                    <span
                      class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium capitalize rounded-xl dark:text-dark-body-text"
                      @click.stop>
                      <div class="flex w-full -mt-10 -ml-8">
                        <TeamMembersSelect
                          :disabled="editing_disabled"
                          label=""
                          @update:selected-team-members="
                            ($event) => {
                              handleInteractionSetTeamMembersList($event, interaction)
                            }
                          " />
                      </div>
                    </span>
                  </span>
                </div>
              </td>
              <td
                v-if="header.id == 'date'"
                class="relative flex gap-2 px-6 mt-2 text-sm whitespace-nowrap text-light-body dark:text-dark-body-text top-4">
                <span v-if="interaction.interaction_date">
                  {{ $moment.utc(interaction.interaction_date).local().format("DD MMM YYYY") }}
                </span>
              </td>
            </template>
          </tr>
        </tbody>
        <tbody v-else class="h-full">
          <tr>
            <td colspan="12">
              <div class="flex flex-col items-center justify-center h-full">
                <h3 class="mt-2 text-xl font-normal text-black dark:text-white">
                  {{
                    interaction_filters?.length ? $t("No available interactions matching applied filters") : $t("No available interactions")
                  }}
                </h3>
                <p class="mt-2 font-normal text-gray-500 text-md">
                  {{
                    interaction_filters?.length
                      ? $t("Clear filters to see original list")
                      : editing_disabled
                        ? ""
                        : $t("Click on the button at the bottom to create a new Interaction.")
                  }}
                </p>
                <img class="flex-shrink-0 mt-4 pointer-events-none h-[100px] w-[100px]" src="@/assets/tasks-completed.png" alt="">
                <div
                  class="flex mt-6 cursor-pointer items-center border-transparent bg-gradient-to-r from-[#2DA7D7] to-[#841FF4] px-6 font-bold text-white rounded-full w-fit-content mr-[4px] h-[50px] content-center text-[14px]"
                  @click="interaction_filters?.length ? handleClickFilter() : editing_disabled ? null : createNewInteraction()">
                  <div class="pl-1" :class="[{ 'has-tooltip': editing_disabled }]">
                    <span v-if="interaction_filters?.length"> {{ $t("Clear filters") }} </span>
                    <span v-else> {{ $t("Create Interaction") }} </span>
                    <span v-if="editing_disabled"
                          class="flex-wrap p-2 bg-gray-300 rounded tooltip whitespace-nowrap mt-7">{{ $t("You don't have access to this feature") }}
                    </span>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else class="relative z-20 px-4 py-2 -mt-1 bg-white">
        <div class="flex items-center align-middle">
          <div class="flex items-center">
            <div>
              <ArrowLeft class="w-6 h-6 mr-2 cursor-pointer text-common-grey" @click="selected_email_or_meeting = null" />
            </div>
            <div
              v-if="
                selected_email_or_meeting.type == 'email' &&
                  (selected_email_or_meeting.origin == 'gmail' || selected_email_or_meeting.origin == 'outlook') &&
                  selected_email_or_meeting?.meta_data?.is_sent === false
              "
              class="relative ml-4">
              <Avatar
                :first-name="
                  selected_email_or_meeting.meta_data.from[0].name
                    ? selected_email_or_meeting.meta_data.from[0].name
                    : selected_email_or_meeting.meta_data.from[0].email
                "
                :last-name="
                  selected_email_or_meeting.meta_data.from[0].name ? selected_email_or_meeting.meta_data.from[0].name.split(' ')[1] : ''
                " />

              <div class="absolute w-5 h-5 p-2 ml-3 -mt-4 bg-white rounded-full" />
              <GoogleIcon v-if="selected_email_or_meeting.origin == 'gmail'" class="absolute ml-3.5 w-4 h-4 -mt-3.5" />
              <MicrosoftIcon v-else-if="selected_email_or_meeting.origin == 'outlook'" class="absolute w-3 h-3 ml-4 -mt-3" />
            </div>

            <div v-if="selected_email_or_meeting?.meta_data.is_sent === false" class="ml-3">
              <p class="text-sm font-medium dark:!text-white text-gray-700 group-hover:text-gray-900">
                {{
                  selected_email_or_meeting.meta_data.from[0].name
                    ? selected_email_or_meeting.meta_data.from[0].name
                    : selected_email_or_meeting.meta_data.from[0].email
                }}
              </p>
              <!-- <p class="text-xs font-medium text-gray-500 group-hover:text-gray-700">View profile</p> -->
            </div>
          </div>

          <div class="ml-10 text-lg font-bold">
            {{ selected_email_or_meeting.name }}
          </div>
          <div class="ml-auto mr-4">
            {{ $moment.utc(selected_email_or_meeting.interaction_date).local().format("DD MMM YYYY") }}
          </div>
          <ActionDropDown
            v-if="
              (selected_email_or_meeting.type == 'email' && selected_email_or_meeting?.meta_data.is_sent === false) ||
                selected_email_or_meeting?.children?.length
            "
            :icon="() => dots_icon()"
            :icon-button="true"
            :actions="getEmailActions(selected_email_or_meeting)"
            @click.stop="" />
          <Reply class="w-0 h-0" />
          <Forward class="w-0 h-0" />
        </div>
        <div class="mt-3">
          <div v-if="selected_email_or_meeting?.meta_data?.to?.length" class="text-sm dark:text-white">
            {{ $t("to") }}:
            {{ selected_email_or_meeting.meta_data?.to?.map((item) => item.email).join(", ") }}
          </div>

          <div v-if="selected_email_or_meeting?.meta_data?.cc?.length" class="text-sm dark:text-white">
            {{ $t("cc") }}:
            {{ selected_email_or_meeting.meta_data?.cc?.map((item) => item.email).join(", ") }}
          </div>

          <div v-if="selected_email_or_meeting?.meta_data?.bcc?.length" class="text-sm dark:text-white">
            {{ $t("bcc") }}:
            {{ selected_email_or_meeting.meta_data?.bcc?.map((item) => item.email).join(", ") }}
          </div>
        </div>
        <div class="mt-10 mb-10 ml-6 dark:text-white" v-html="selected_email_or_meeting.description" />

        <div v-for="(child_email, index) in selected_email_or_meeting.children" :key="child_email.id">
          <ChildEmail
            v-if="shouldShowChildEmail(index)"
            :initially-expanded="selected_email_or_meeting.children.length - 1 == index"
            :email="selected_email_or_meeting.children[selected_email_or_meeting.children.length - 1 - index]" />
          <ExpandChildEmailsButton
            v-if="!expand_all_child_emails && selected_email_or_meeting.children.length - 2 > 0 && index == 1"
            class="h-0"
            :collapsed-emails="selected_email_or_meeting.children.length - 2"
            @click="handleExpandChildrenClick" />
        </div>

        <div v-if="selected_email_or_meeting.type == 'meeting' && selected_email_or_meeting.meta_data" class="font-light text-common-grey">
          <span class="mr-3 font-bold">{{ $t("Time") }}</span>
          <span class="ml-4">{{ $moment(selected_email_or_meeting.interaction_date).format("dddd MMM DD, YYYY") }}</span>
          -
          <span class="ml-2">{{
            selected_email_or_meeting.meta_data?.when?.object == "timespan"
              ? `${$moment.unix(selected_email_or_meeting.meta_data.when.start_time).format("hh:mm A")} -
                                      ${$moment.unix(selected_email_or_meeting.meta_data.when.end_time).format("hh:mm A")}`
              : ""
          }}</span>
        </div>

        <div
          v-if="selected_email_or_meeting.type == 'meeting'"
          :class="[` max-h-14 py-4 pt-2 mt-5  rounded-t-lg flex text-center  justify-center w-[340px]`]">
          <div class="text-common-grey font-bold mr-4 mt-0.5">
            {{ $t("Attending") }}:
          </div>
          <div
            :class="[
              `cursor-pointer w-1/3 border dark:border-dark-divider-border py-4 px-0 rounded-l-md   ${
                selected_email_or_meeting.meta_data.participants.filter((p) => p.email == $store.state.auth.user.email)[0]?.status == 'yes'
                  ? ' text-white bg-light-brand-blue'
                  : 'bg-white dark:bg-dark-screen-background dark:text-white'
              }`
            ]"
            @click="handleAttend('yes')">
            <span :class="[`relative -top-2.5`]">{{ $t("Yes") }} </span>
          </div>
          <div
            :class="[
              `cursor-pointer w-1/3 border dark:border-dark-divider-border py-4 px-0  ${
                selected_email_or_meeting.meta_data.participants.filter((p) => p.email == $store.state.auth.user.email)[0]?.status == 'no'
                  ? ' text-white bg-blue'
                  : 'bg-white dark:bg-dark-screen-background dark:text-white'
              }`
            ]"
            @click="handleAttend('no')">
            <span :class="[`relative -top-2.5`]">{{ $t("No") }} </span>
          </div>
          <div
            :class="[
              `cursor-pointer w-1/3 border dark:border-dark-divider-border py-4 px-0 rounded-r-md ${
                selected_email_or_meeting.meta_data.participants.filter((p) => p.email == $store.state.auth.user.email)[0]?.status ==
                'maybe'
                  ? ' text-white bg-blue'
                  : 'bg-white dark:bg-dark-screen-background dark:text-white'
              }`
            ]"
            @click="handleAttend('maybe')">
            <span :class="[`relative -top-2.5`]">{{ $t("Maybe") }} </span>
          </div>
        </div>

        <div v-if="selected_email_or_meeting.type == 'meeting'" :class="[` py-4 pt-2  rounded-t-lg   mt-3 flex`]">
          <div class="mr-4 font-bold text-common-grey">
            {{ $t("Participants") }}:
          </div>
          <div>
            <div v-for="participant in selected_email_or_meeting.meta_data.participants" :key="participant.email" class="dark:text-white">
              {{ participant.email }} -
              <span
                :class="[
                  `${
                    participant.status == 'yes'
                      ? 'text-green-success'
                      : participant.status == 'no'
                        ? 'text-status-error-red'
                        : participant.status == 'maybe'
                          ? 'text-status-warning-yellow'
                          : 'text-common-grey'
                  }`
                ]">
                {{
                  participant.status == "yes"
                    ? $t("Attending")
                    : participant.status == "no"
                      ? $t("Not Attending")
                      : participant.status == "maybe"
                        ? $t("Maybe")
                        : $t("No Reply")
                }}
              </span>
            </div>
          </div>
        </div>

        <a
          v-if="selected_email_or_meeting.meta_data?.conferencing && selected_email_or_meeting.type == 'meeting'"
          target="_blank"
          :href="selected_email_or_meeting.meta_data?.conferencing?.details?.url"
          class="relative btn primary-btn p-3 mr-5 rounded-md cursor-pointer text-white w-[350px] mt-2 mb-4 text-center">
          <span :class="[`${selected_email_or_meeting.meta_data?.conferencing?.details?.pin ? 'bottom-1.5 relative' : ''}`]">{{
            $t("Join Meeting")
          }}</span>
          <div v-if="selected_email_or_meeting.meta_data?.conferencing?.details?.pin" class="absolute text-xs bottom-0.5">
            {{ $t("PIN") }}
            {{ selected_email_or_meeting.meta_data.conferencing.details.pin }}
          </div>
        </a>
      </div>
      <div class="w-full bg-white dark:bg-dark-box-background">
        <div class="absolute bottom-0 w-full pt-2 overflow-visible bg-white border-t h-14 dark:bg-dark-box-background">
          <PaginationFooter :min-page-size="5" :default-page-size="page_size" :object="interactions" @update="updateInteractionsPage" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ListFilter,
  ChevronDown,
  ChevronUp,
  ChevronsUpDown,
  Plus,
  Trash2,
  User,
  Users,
  EllipsisVertical,
  Link,
  Mail,
  MessagesSquare,
  Pencil,
  ArrowLeft,
  Phone,
  ClipboardCheck,
  ArrowLeftFromLine,
  LayoutPanelTop,
  Forward,
  Reply,
  UsersRound,
  Megaphone,
  StickyNote,
  Wrench
} from "lucide-vue-next"
import ActionDropDown from "@/components/shared/ActionDropDown.vue"
import WhatsappIcon from "@/components/shared/icons/WhatsappIcon.vue"
import Avatar from "@/components/shared/Avatar.vue"
import GmailIcon from "@/components/shared/icons/GmailIcon.vue"
import GoogleIcon from "@/components/shared/icons/GoogleIcon.vue"
import OutlookIcon from "@/components/shared/icons/OutlookIcon.vue"
import MicrosoftIcon from "@/components/shared/icons/MicrosoftIcon.vue"
import ContactsSelect from "@/components/shared/ContactsSelect.vue"
import TeamMembersSelect from "@/components/shared/TeamMembersSelect.vue"
import ChildEmail from "@/components/shared/ChildEmail.vue"
import ExpandChildEmailsButton from "@/components/shared/ExpandChildEmailsButton.vue"
import { event as google_event } from "vue-gtag-next"
import { Record } from "@/models/record"
import Badge from "@/components/shared/ActivityStatusBadge.vue"
import ActivitiesColumnsFilter from "@/components/shared/ActivitiesColumnsFilter.vue"
import { markRaw } from "vue"
import dataService from "@/services/data.service"
import NotesIcon from "@/components/shared/icons/NotesIcon.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import draggable from "vuedraggable"
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue"
import PaginationFooter from "@/components/shared/PaginationFooter.vue"

export default {
  components: {
    WhatsappIcon,
    ArrowLeftFromLine,
    draggable,
    NotesIcon,
    Pencil,
    LayoutPanelTop,
    PaginationFooter,
    Link,
    MessagesSquare,
    ActivitiesColumnsFilter,
    ChevronDown,
    ListFilter,
    ChevronUp,
    ChevronsUpDown,
    Trash2,
    User,
    Users,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    Badge: markRaw(Badge),
    ActionDropDown,
    UsersRound,
    Plus,
    Phone,
    Mail,
    Avatar,
    StickyNote,
    Megaphone,
    Wrench,
    GmailIcon,
    GoogleIcon,
    Reply,
    Forward,
    ArrowLeft,
    OutlookIcon,
    MicrosoftIcon,
    ClipboardCheck: markRaw(ClipboardCheck),
    ContactsSelect,
    ChildEmail,
    ExpandChildEmailsButton,
    TeamMembersSelect,
    EllipsisVertical
  },
  inject: ["canUserEditLayout", "updateCursorPosition"],
  props: {
    initialFilter: {
      type: Object,
      default: () => ({})
    },
    connectTo: {
      type: String,
      default: ""
    },
    linkedRecord: null,
    componentReference: {
      type: String,
      required: false
    },
    preservedPageSize: {
      type: Number,
      default: 5
    },
    currentTemplate: {
      type: Object,
      required: false
    },
    currentCompany: {
      type: Object,
      required: false
    },
    showNylasItemsGmail: {
      type: Boolean,
      required: false
    },
    showNylasItemsOutlook: {
      type: Boolean,
      required: false
    }
  },
  emits: ["preservedFilters", "cancel"],
  data() {
    return {
      all_headers: [
        {
          label: this.$t("Type"),
          id: "type",
          name: this.$t("Type"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Category"),
          id: "category",
          name: this.$t("Category"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Assigned Tags"),
          id: "tags",
          name: this.$t("Assigned Tags"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Company/Opportunity"),
          id: "companies",
          name: this.$t("Company/Opportunity"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Contacts"),
          id: "contacts",
          name: this.$t("Contacts"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Team Members"),
          id: "collaborators",
          name: this.$t("Team Members"),
          sort: 0,
          value: null
        },
        {
          label: this.$t("Date"),
          id: "date",
          name: this.$t("Date"),
          sort: 0,
          value: null
        }
      ],
      interaction_filters: [],
      current_column_filter_valid: false,
      current_column_filter: null,
      click_position: null,
      fetching_in_progress: false,
      all_tags: [],
      drag: false,
      ordering_query: "",
      interaction_headers: [],
      ALL_EMITTERS,
      interactions_top_scroll: 0,
      Record,
      task_icon: ClipboardCheck,
      dots_icon: EllipsisVertical,

      //interactions
      interactions: { results: [], count: 0 },
      interaction_types: [],
      interaction_type_categories: [],
      interaction_categories: [],
      interaction_companies: null,
      interaction_contacts: null,
      interaction_users: null,
      interaction_due_date_range: null,

      selected_email_or_meeting: null,
      dont_fetch: false,
      expand_all_child_emails: false,
      tied_record_full: null,
      page_size: 5
    }
  },
  computed: {
    current_headers() {
      return this.$store.state.ui_options.interactions_activities_table_headers
    },
    editing_disabled() {
      let editing_disabled_calc = false

      if (this.$route.name == "WorkspaceItem" && this.$store.state.ui.workspace_user_access_scope == "read") {
        editing_disabled_calc = true
      }

      if (this.$route.name == "Dashboard" && this.$route.params.page) {
        const current_template = this.$store.state.portfolio.shared_layouts.find((l) => l.id == this.$route.params.page)
        if (!this.canUserEditLayout(this.$store.state.auth.user, current_template)) {
          editing_disabled_calc = true
        }
      }

      return editing_disabled_calc
    },
    tied_record() {
      if (this.initialFilter?.companies?.includes("this_record") || this.connectTo == "this_record") {
        return this.$route.params.cid
      } else if (this.connectTo == "another_record") {
        return this.linkedRecord
      } else {
        return null
      }
    }
  },

  watch: {
    interaction_filters: {
      deep: true,
      handler() {
        this.getInteractions()
      }
    },
    current_headers() {
      this.refreshTableView()
    },
    initialFilter: {
      deep: true,
      handler() {
        this.refetchList()
      }
    },
    tied_record_full() {
      this.getInteractions()
    },
    connectTo() {
      this.getTiedCompany()
    },
    linkedRecord: {
      deep: true,
      handler() {
        this.getTiedCompany()
      }
    },
    currentCompany() {
      this.tied_record_full = this.currentCompany
    },

    //interaction filters
    interaction_types: {
      deep: true,
      handler() {
        let catogeries = []

        this.interaction_types?.forEach((t) => {
          const type_full = this.$store.state.data.interaction_types.filter((type) => type.value == t)[0]
          catogeries = catogeries.concat(type_full.categories)
        })
        const unique_categories = catogeries?.filter((v, i, a) => a.findIndex((v2) => v2?.value === v?.value) === i)

        this.interaction_type_categories = unique_categories

        if (!this.interaction_types?.length) {
          this.interaction_type_categories = this.$store.state.data.interaction_categories
        }
        if (!this.dont_fetch) {
          this.getInteractions()
        }
      }
    },
    interaction_categories: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getInteractions()
        }
      }
    },
    interaction_companies: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getInteractions()
        }
      }
    },
    interaction_contacts: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getInteractions()
        }
      }
    },
    interaction_users: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getInteractions()
        }
      }
    },
    interaction_due_date_range: {
      deep: true,
      handler() {
        if (!this.dont_fetch) {
          this.getInteractions()
        }
      }
    },
    showNylasItemsGmail: {
      handler() {
        if (!this.dont_fetch) {
          this.getInteractions()
        }
      }
    },
    showNylasItemsOutlook: {
      handler() {
        if (!this.dont_fetch) {
          this.getInteractions()
        }
      }
    },
    "$store.state.ui.currentCompany": {
      deep: true,
      handler() {
        this.$emitter.emit(ALL_EMITTERS.CURRENT_COMPANY_UPDATED_IN_ACTIONS_TABLE)
      }
    }
  },
  mounted() {
    const elements = document.getElementsByClassName("col-table-header-btn")
    elements.forEach((el) => {
      el.addEventListener(
        "click",
        (e) => {
          this.updateCursorPosition(e)
        },
        true
      )
    })
  },
  created() {
    this.all_tags = this.$store.state.data.actions_tags
    this.refreshTableView()
    if (this.preservedPageSize) {
      this.page_size = this.preservedPageSize
    }
    this.register_listeners()
    this.interaction_type_categories = this.$store.state.data.interaction_categories
    this.getTiedCompany()
  },

  activated() {
    this.refetchList()
    this.register_listeners()
    this.getTiedCompany()
  },

  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },

  methods: {
    updateInteractionsHeaders() {
      this.drag = false
      this.$store.dispatch("ui/setUIValue", {
        interactions_activities_table_headers: {
          ...this.$store.state.ui_options.interactions_activities_table_headers,
          [this.componentReference]: this.interaction_headers.slice(1).map((header) => header.id)
        }
      })
    },
    sortRecords() {
      this.ordering_query = this.interaction_headers
        .filter((h) => h.id != "actions" && h.id != "tags" && h.id != "companies" && h.id != "contacts" && h.id != "collaborators")
        .filter((el) => el.sort != 0)
        .sort((a, b) => a.sort_index - b.sort_index)
        .map((el) => `${String(el.sort).replace("1", "")}${el.id}`)
        .join(",")
      this.getInteractions()
    },
    handleChangeColumnFilter(column_filter) {
      this.current_column_filter = column_filter
    },
    sortActivities() {},
    handleRemoveColumnFilter(element, closeFilterModal, close) {
      let index
      if (element.id == "date") {
        index = this.interaction_filters.findIndex((x) => x["interaction_date_start"])
        if (index != -1) {
          this.interaction_filters.splice(index, 1)
        }
        index = this.interaction_filters.findIndex((x) => x["interaction_date_end"])
        if (index != -1) {
          this.interaction_filters.splice(index, 1)
        }
        index = this.interaction_headers.findIndex((x) => x.id == element.id)
        if (index != -1) {
          this.interaction_headers[index].value = null
        }
      } else if (element.id == "companies") {
        index = this.interaction_filters.findIndex((x) => x["records"])
        if (index != -1) {
          this.interaction_filters.splice(index, 1)
        }
        index = this.interaction_headers.findIndex((x) => x.id == element.id)
        if (index != -1) {
          this.interaction_headers[index].value = null
        }
      } else if (element.id == "collaborators") {
        index = this.interaction_filters.findIndex((x) => x["users"])
        if (index != -1) {
          this.interaction_filters.splice(index, 1)
        }
        index = this.interaction_headers.findIndex((x) => x.id == element.id)
        if (index != -1) {
          this.interaction_headers[index].value = null
        }
      } else {
        index = this.interaction_filters.findIndex((x) => x[element.id])
        if (index != -1) {
          this.interaction_filters.splice(index, 1)
        }
        index = this.interaction_headers.findIndex((x) => x.id == element.id)
        if (index != -1) {
          this.interaction_headers[index].value = null
        }
      }
      closeFilterModal()
      close()
    },
    handleSubmitColumnFilter(closeFilterModal, close) {
      let column, value, column2, value2
      if (this.current_column_filter.id == "name") {
        column = "name"
        value = this.current_column_filter.value
      } else if (this.current_column_filter.id == "companies") {
        column = "records"
        value = this.current_column_filter.value.map((c) => c.id).join(",")
      } else if (this.current_column_filter.id == "contacts") {
        column = this.current_column_filter.id
        value = this.current_column_filter.value.map((c) => c.id).join(",")
      } else if (this.current_column_filter.id == "collaborators") {
        column = "users"
        value = this.current_column_filter.value.join(",")
      } else if (this.current_column_filter.id == "status") {
        column = this.current_column_filter.id
        value = [this.current_column_filter.value].join(",")
      } else if (this.current_column_filter.id == "type") {
        column = "type"
        value = this.current_column_filter.value.join(",")
      } else if (this.current_column_filter.id == "tags") {
        column = "tags"
        value = this.current_column_filter.value.join(",")
      } else if (this.current_column_filter.id == "category") {
        column = "category"
        value = this.current_column_filter.value.join(",")
      } else if (this.current_column_filter.id == "date") {
        column = "interaction_date_start"
        value = this.$moment(this.current_column_filter.value.start).startOf("day").toISOString()
        column2 = "interaction_date_end"
        value2 = this.$moment(this.current_column_filter.value.end).startOf("day").toISOString()
      }
      let index = this.interaction_filters.findIndex((x) => x[column])
      if (index != -1) {
        this.interaction_filters[index][column] = value
      } else {
        this.interaction_filters.push({ [column]: value })
      }
      if (column2) {
        index = this.interaction_filters.findIndex((x) => x[column2])
        if (index != -1) {
          this.interaction_filters[index][column2] = value2
        } else {
          this.interaction_filters.push({ [column2]: value2 })
        }
      }
      closeFilterModal()
      close()
    },
    refreshTableView() {
      if (this.$store.state.ui_options.interactions_activities_table_headers) {
        if (this.$store.state.ui_options.interactions_activities_table_headers[this.componentReference]) {
          this.interaction_headers = this.$store.state.ui_options.interactions_activities_table_headers[this.componentReference].map(
            (header_id) => {
              let header = this.all_headers.find((x) => x.id == header_id) || {
                id: header_id,
                label: header_id
              }
              return { ...header }
            }
          )
        } else {
          this.interaction_headers = this.all_headers.map((header) => header)
        }
      } else {
        this.interaction_headers = this.all_headers.map((header) => header)
        this.$store.dispatch("ui/setUIValue", {
          interactions_activities_table_headers: {
            [this.componentReference]: this.all_headers.map((x) => x.id)
          }
        })
      }
      if (!this.editing_disabled) {
        this.interaction_headers.unshift({ label: "", id: "actions" })
      }
    },
    showAllAssignedTags(object) {
      if (object?.is_all_assigned_tags_shown) {
        object["is_all_assigned_tags_shown"] = false
      } else {
        object["is_all_assigned_tags_shown"] = true
      }
    },
    updateInteractionsPage({ page, page_size }) {
      this.$emit("preservedFilters", { page: page, page_size: page_size })
      this.page_size = page_size
      this.getInteractions(page, page_size)
    },
    handleInteractionsScroll(e) {
      this.interactions_top_scroll = e.target.scrollTop
    },
    getRecordActions(record) {
      return [
        {
          name: this.$t("Visit") + ` ${this.$utils.getRecordName(record)}`,
          action: () => {
            this.$utils.Record(record).open()
          },
          icon: "Link"
        },
        {
          name: this.$t("View notes"),
          action: () => {
            this.openModalNotes(record)
          },
          icon: "StickyNote"
        },
        {
          name: this.$t("Create Interaction"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_INTERACTION, {
              record: record
            })
          },
          icon: "MessagesSquare"
        },

        {
          name: this.$t("Assign Owner"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CREATE_OWNER, { record: record })
          },
          icon: "User"
        },
        {
          name: this.$t("Assign Co-owners"),
          action: () => {
            this.$emitter.emit(ALL_EMITTERS.CHANGE_CO_OWNERS, {
              record: record
            })
          },
          icon: "Users"
        },

        {
          name: this.$t("Send Email"),
          action: () => {
            const i_service = this.$store.state.integration.integrations.find((i) => i.name == "gmail")
            if (i_service && i_service.scope.includes("https://www.googleapis.com/auth/gmail.modify")) {
              if (i_service.status == "on") {
                this.$emitter.emit(ALL_EMITTERS.SEND_EMAIL, {
                  record: record,
                  object_type: record.type
                })
              } else {
                this.$emitter.emit(ALL_EMITTERS.INTEGRATION_MISSING_MODAL, {
                  message: this.$t("Email integration is not active, Activate integration to send an email")
                })
              }
            } else {
              this.$emitter.emit(ALL_EMITTERS.INTEGRATION_MISSING_MODAL, {
                message: this.$t("In order to send an email please link your account to your Email.")
              })
            }
          },
          icon: "Mail"
        }
      ]
    },
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.CURRENT_COMPANY_UPDATED_IN_ACTIONS_TABLE, () => {
        if (this.connectTo !== "another_record" && this.$store.state.ui.currentCompany) {
          this.getTiedCompany()
        }
      })
      this.$emitter.on(ALL_EMITTERS.NEW_INTERACTION_ADDED, (interaction) => {
        google_event("create_interaction_click", {
          event_label: "Create new interaction",
          page: this.currentTemplate.page,
          name: this.currentTemplate.name,
          user_name: this.$store.state.auth.user.full_name,
          user_email: this.$store.state.auth.user.email,
          organization: this.$store.state.organization.name
        })
        this.addRemoveOrUpdateActionInTableRelatedToFilters(interaction, "interaction")
      })
      this.$emitter.on(ALL_EMITTERS.INTERACTION_UPDATED, (interaction) => {
        this.addRemoveOrUpdateActionInTableRelatedToFilters(interaction, "interaction", true)
      })
      this.$emitter.on(ALL_EMITTERS.INTERACTION_REMOVED, (interaction) => {
        const index = this.interactions?.results.findIndex((p) => p.id == interaction.id)
        this.$utils.removeItem(this.interactions?.results, interaction, "id")
        if (index !== -1) {
          this.interactions.count -= 1
        }
      })
      this.$emitter.on(ALL_EMITTERS.UPDATE_COUNT_NOTES_IN_RECORDS_TABLE, ({ id: id, count: count }) => {
        this.interactions.results.map((interaction) => {
          if (interaction?.record?.id == id) {
            interaction.record["notes_summary"]["count"] = count
          }
        })
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.CURRENT_COMPANY_UPDATED_IN_ACTIONS_TABLE)
      this.$emitter.off(ALL_EMITTERS.NEW_INTERACTION_ADDED)
      this.$emitter.off(ALL_EMITTERS.INTERACTION_UPDATED)
      this.$emitter.off(ALL_EMITTERS.INTERACTION_REMOVED)
      this.$emitter.off(ALL_EMITTERS.UPDATE_COUNT_NOTES_IN_RECORDS_TABLE)
    },

    addRemoveOrUpdateActionInTableRelatedToFilters(item, item_type, updated) {
      const all_filters = {}

      all_filters["status"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_status`]
      all_filters["name"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_search_term`]
      all_filters["companies"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_companies`]
      all_filters["contacts"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_contacts`]
      all_filters["assigned_to"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_assigned_to`]
      all_filters["due_date_start"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_due_date_range`]?.start
      all_filters["due_date_end"] = this[`${item_type}${item_type !== "interaction" ? "s" : ""}_due_date_range`]?.end

      if (this.initialFilter?.types && this.$store.state.data[`${item_type}_types`]) {
        all_filters["type"] = this.$store.state.data[`${item_type}_types`]
          .filter((t) => this.initialFilter.types.includes(t.value))
          .map((t) => t.value)
      }

      if (this.initialFilter?.categories) {
        all_filters["category"] = this.$store.state.data.interaction_categories
          .filter((t) => this.initialFilter.types.includes(t.value))
          .map((t) => t.value)
      }

      let should_add_to_table = true

      if (all_filters["status"]?.length) {
        let item_status = item.status
        if (item.show_dynamic_status) {
          item_status = item.summary.dynamic_status
        }
        if (!all_filters["status"].includes(item_status)) {
          should_add_to_table = false
        }
      }

      if (all_filters["companies"]?.length) {
        let item_companies = null
        if (item_type == "plan") {
          item_companies = item.companies
        } else {
          item_companies = [item.record]
        }
        if (!all_filters["companies"].filter((c) => item_companies.map((c) => c.id).includes(c.id)).length) {
          should_add_to_table = false
        }
      }

      if (all_filters["contacts"]?.length) {
        if (!all_filters["contacts"].filter((c) => item.contacts.map((c) => c.id).includes(c.id)).length) {
          should_add_to_table = false
        }
      }

      if (all_filters["assigned_to"]?.length) {
        let item_users = null
        if (item_type == "plan") {
          item_users = item.collaborators
        } else {
          item_users = item.assigned_to
        }
        if (!all_filters["assigned_to"].filter((c) => item_users.map((c) => (c.id ? c.id : c)).includes(c)).length) {
          should_add_to_table = false
        }
      }

      if (this.initialFilter?.relative_due_date) {
        const relative_due_date_text = this.initialFilter?.relative_due_date

        if (relative_due_date_text !== null && relative_due_date_text !== "") {
          const today = new Date()
          if (relative_due_date_text === "today") {
            const startOfDay = new Date(today)
            startOfDay.setHours(0, 0, 0, 0)
            const endOfDay = new Date(today)
            endOfDay.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfDay
            all_filters["due_date_end"] = endOfDay
          } else if (relative_due_date_text === "tomorrow") {
            const tomorrow = new Date(today)
            tomorrow.setDate(today.getDate() + 1)
            const startOfTomorrow = new Date(tomorrow)
            startOfTomorrow.setHours(0, 0, 0, 0)
            const endOfTomorrow = new Date(tomorrow)
            endOfTomorrow.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfTomorrow
            all_filters["due_date_end"] = endOfTomorrow
          } else if (relative_due_date_text === "yesterday") {
            const yesterday = new Date(today)
            yesterday.setDate(today.getDate() - 1)
            const startOfYesterday = new Date(yesterday)
            startOfYesterday.setHours(0, 0, 0, 0)
            const endOfYesterday = new Date(yesterday)
            endOfYesterday.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfYesterday
            all_filters["due_date_end"] = endOfYesterday
          } else if (relative_due_date_text === "this_week") {
            const startOfWeek = new Date(today)
            startOfWeek.setDate(today.getDate() - today.getDay())
            const endOfWeek = new Date(today)
            endOfWeek.setDate(startOfWeek.getDate() + 6)
            endOfWeek.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfWeek
            all_filters["due_date_end"] = endOfWeek
          } else if (relative_due_date_text === "next_week") {
            const startOfNextWeek = new Date(today)
            startOfNextWeek.setDate(today.getDate() - today.getDay() + 7)
            const endOfNextWeek = new Date(startOfNextWeek)
            endOfNextWeek.setDate(startOfNextWeek.getDate() + 6)
            endOfNextWeek.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfNextWeek
            all_filters["due_date_end"] = endOfNextWeek
          } else if (relative_due_date_text === "last_week") {
            const startOfLastWeek = new Date(today)
            startOfLastWeek.setDate(today.getDate() - today.getDay() - 7)
            const endOfLastWeek = new Date(startOfLastWeek)
            endOfLastWeek.setDate(startOfLastWeek.getDate() + 6)
            endOfLastWeek.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfLastWeek
            all_filters["due_date_end"] = endOfLastWeek
          } else if (relative_due_date_text === "this_month") {
            const startOfMonth = new Date(today)
            startOfMonth.setDate(1)
            const endOfMonth = new Date(today)
            endOfMonth.setMonth(endOfMonth.getMonth() + 1)
            endOfMonth.setDate(0)
            endOfMonth.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfMonth
            all_filters["due_date_end"] = endOfMonth
          } else if (relative_due_date_text === "next_month") {
            const startOfNextMonth = new Date(today)
            startOfNextMonth.setMonth(startOfNextMonth.getMonth() + 1)
            startOfNextMonth.setDate(1)
            const endOfNextMonth = new Date(startOfNextMonth)
            endOfNextMonth.setMonth(endOfNextMonth.getMonth() + 1)
            endOfNextMonth.setDate(0)
            endOfNextMonth.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfNextMonth
            all_filters["due_date_end"] = endOfNextMonth
          } else if (relative_due_date_text === "last_month") {
            const startOfLastMonth = new Date(today)
            startOfLastMonth.setMonth(startOfLastMonth.getMonth() - 1)
            startOfLastMonth.setDate(1)
            const endOfLastMonth = new Date(startOfLastMonth)
            endOfLastMonth.setMonth(endOfLastMonth.getMonth() + 1)
            endOfLastMonth.setDate(0)
            endOfLastMonth.setHours(23, 59, 59, 999)
            all_filters["due_date_start"] = startOfLastMonth
            all_filters["due_date_end"] = endOfLastMonth
          } else if (relative_due_date_text === "this_quarter") {
            const quarter = Math.floor((today.getMonth() - 1) / 3) + 1
            let startOfQuarter, endOfQuarter
            if (quarter === 1) {
              startOfQuarter = new Date(today.getFullYear(), 0, 1)
              endOfQuarter = new Date(today.getFullYear(), 2, 31, 23, 59, 59, 999)
            } else if (quarter === 2) {
              startOfQuarter = new Date(today.getFullYear(), 3, 1)
              endOfQuarter = new Date(today.getFullYear(), 5, 30, 23, 59, 59, 999)
            } else if (quarter === 3) {
              startOfQuarter = new Date(today.getFullYear(), 6, 1)
              endOfQuarter = new Date(today.getFullYear(), 8, 30, 23, 59, 59, 999)
            } else {
              startOfQuarter = new Date(today.getFullYear(), 9, 1)
              endOfQuarter = new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
            }
            all_filters["due_date_start"] = startOfQuarter
            all_filters["due_date_end"] = endOfQuarter
          } else if (relative_due_date_text === "next_quarter") {
            let startOfNextQuarter, endOfNextQuarter
            if (today.getMonth() >= 9) {
              // October, November, December
              startOfNextQuarter = new Date(today.getFullYear() + 1, 0, 1)
              endOfNextQuarter = new Date(today.getFullYear() + 1, 2, 31, 23, 59, 59, 999)
            } else {
              const quarter = Math.floor((today.getMonth() - 1) / 3) + 2
              if (quarter === 2) {
                startOfNextQuarter = new Date(today.getFullYear(), 3, 1)
                endOfNextQuarter = new Date(today.getFullYear(), 5, 30, 23, 59, 59, 999)
              } else if (quarter === 3) {
                startOfNextQuarter = new Date(today.getFullYear(), 6, 1)
                endOfNextQuarter = new Date(today.getFullYear(), 8, 30, 23, 59, 59, 999)
              } else {
                startOfNextQuarter = new Date(today.getFullYear(), 9, 1)
                endOfNextQuarter = new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
              }
            }
            all_filters["due_date_start"] = startOfNextQuarter
            all_filters["due_date_end"] = endOfNextQuarter
          } else if (relative_due_date_text === "last_quarter") {
            let startOfLastQuarter, endOfLastQuarter
            if (today.getMonth() <= 2) {
              // January, February, March
              startOfLastQuarter = new Date(today.getFullYear() - 1, 9, 1)
              endOfLastQuarter = new Date(today.getFullYear() - 1, 11, 31, 23, 59, 59, 999)
            } else {
              const quarter = Math.floor((today.getMonth() - 1) / 3)
              if (quarter === 1) {
                startOfLastQuarter = new Date(today.getFullYear(), 0, 1)
                endOfLastQuarter = new Date(today.getFullYear(), 2, 31, 23, 59, 59, 999)
              } else if (quarter === 2) {
                startOfLastQuarter = new Date(today.getFullYear(), 3, 1)
                endOfLastQuarter = new Date(today.getFullYear(), 5, 30, 23, 59, 59, 999)
              } else {
                startOfLastQuarter = new Date(today.getFullYear(), 6, 1)
                endOfLastQuarter = new Date(today.getFullYear(), 8, 30, 23, 59, 59, 999)
              }
            }
            all_filters["due_date_start"] = startOfLastQuarter
            all_filters["due_date_end"] = endOfLastQuarter
          } else if (relative_due_date_text === "this_year") {
            const startOfYear = new Date(today.getFullYear(), 0, 1)
            const endOfYear = new Date(today.getFullYear(), 11, 31, 23, 59, 59, 999)
            all_filters["due_date_start"] = startOfYear
            all_filters["due_date_end"] = endOfYear
          } else if (relative_due_date_text === "next_year") {
            const startOfNextYear = new Date(today.getFullYear() + 1, 0, 1)
            const endOfNextYear = new Date(today.getFullYear() + 1, 11, 31, 23, 59, 59, 999)

            all_filters["due_date_start"] = startOfNextYear
            all_filters["due_date_end"] = endOfNextYear
          } else if (relative_due_date_text === "last_year") {
            const startOfLastYear = new Date(today.getFullYear() - 1, 0, 1)
            const endOfLastYear = new Date(today.getFullYear() - 1, 11, 31, 23, 59, 59, 999)
            all_filters["due_date_start"] = startOfLastYear
            all_filters["due_date_end"] = endOfLastYear
          }
        }
      }

      if (all_filters["due_date_start"]) {
        if (
          !(
            new Date(item.due_date) >= new Date(all_filters["due_date_start"]) &&
            new Date(item.due_date) <= new Date(all_filters["due_date_end"])
          )
        ) {
          should_add_to_table = true
        }
      }

      if (should_add_to_table) {
        if (!this[`${item_type}s`].results.find((i) => i.id == item.id)) {
          this[`${item_type}s`].count += 1
        }
        this.$utils.replaceOrAddItem(this[`${item_type}s`].results, item, "id", true)
      } else if (updated) {
        const index = this[`${item_type}s`].results.findIndex((p) => p.id == item.id)
        this.$utils.removeItem(this[`${item_type}s`].results, item, "id")
        if (index !== -1) {
          this[`${item_type}s`].count -= 1
        }
      }
    },
    getTiedCompany() {
      if (
        (this.connectTo == "this_record" || this.initialFilter?.companies?.includes("this_record")) &&
        this.$store.state.ui.currentCompany
      ) {
        this.tied_record_full = this.$store.state.ui.currentCompany
        this.getInteractions()
      } else if (this.connectTo == "another_record") {
        this.$store.dispatch("data/getRecord", this.linkedRecord.id ? this.linkedRecord.id : this.linkedRecord).then(() => {
          this.tied_record_full = this.$store.state.data.records_fetched[this.linkedRecord.id ? this.linkedRecord.id : this.linkedRecord]
          this.getInteractions()
        })
      } else {
        this.getInteractions()
      }
    },
    refetchList() {
      this.getInteractions()
    },
    calculateUnread(email) {
      if (email.meta_data?.unread) {
        return true
      }
      if (email.meta_data?.children?.length) {
        email.meta_data?.children.forEach((child_email) => {
          if (child_email?.meta_data.unread) {
            return true
          }
        })
      }
      return false
    },
    handleExpandChildrenClick() {
      this.expand_all_child_emails = true
    },
    shouldShowChildEmail(index) {
      if (this.selected_email_or_meeting.children.length < 2) {
        return true
      }
      if (this.expand_all_child_emails) {
        return true
      }
      if (!index || index == this.selected_email_or_meeting.children.length - 1) {
        return true
      }
      return false
    },
    handleClickFilter() {
      this.interaction_filters = []
      this.interaction_headers.map((header) => (header["value"] = null))
    },
    openModalNotes(record) {
      this.$emitter.emit(ALL_EMITTERS.ADD_NOTES_RECORD, { company: record })
    },
    handleInteractionSetContactsList(e, interaction) {
      const post = {
        id: interaction.id,
        dont_load: true,
        contacts: e.map((c) => c.id)
      }
      this.$store.dispatch("data/updateInteraction", { interaction: post }).then(() => {})
    },
    handleInteractionSetTeamMembersList(e, interaction) {
      const post = {
        id: interaction.id,
        dont_load: true,
        users: e.map((u) => u.id)
      }
      this.$store.dispatch("data/updateInteraction", { interaction: post }).then(() => {})
    },
    handleAttend(status) {
      let index = this.selected_email_or_meeting.meta_data.participants.findIndex((p) => p.email == this.$store.state.auth.user.email)
      const found_user = this.selected_email_or_meeting.meta_data.participants[index]
      this.selected_email_or_meeting.meta_data.participants.splice(index, 1, {
        ...found_user,
        status: status
      })

      //Perform BE requestp
    },

    openDetails(interaction) {
      if ((interaction.origin == "gmail" || interaction.origin == "outlook") && interaction.type == "email") {
        this.selected_email_or_meeting = interaction
        this.expand_all_child_emails = false
      } else {
        this.$emitter.emit(ALL_EMITTERS.UPDATE_INTERACTION, {
          interaction: this.$utils.clone(interaction)
        })
      }
    },
    createNewInteraction() {
      if (!this.tied_record) {
        return this.$emitter.emit(ALL_EMITTERS.CREATE_INTERACTION)
      } else {
        const data = {
          record: this.tied_record_full
        }
        if (this.tied_record_full?.type !== "company" && this.tied_record_full?.type !== "opportunity") {
          if (this.tied_record_full.parent) {
            data["record"] = this.tied_record_full.parent
          }
          if (this.tied_record_full?.type == "contact") {
            data["contact"] = this.tied_record_full
          }
        }
        return this.$emitter.emit(ALL_EMITTERS.CREATE_INTERACTION, data)
      }
    },
    loadMoreActions(page) {
      const action_name = "interactions"
      let url_calc
      if (this[action_name].next) {
        url_calc = this[action_name].next.replace(/page=\d+/, `page=${page}`)
      } else {
        url_calc = this[action_name].previous.replace(/page=\d+/, `page=${page}`)
      }
      dataService.getRecordsByUrl(url_calc).then((res) => {
        this[action_name] = { ...res.data, results: res.data.results }
      })
    },
    getInteractions(page = 1, page_size = this.page_size) {
      if (!this.fetching_in_progress) {
        this.fetching_in_progress = true
        setTimeout(() => {
          this.fetching_in_progress = false
        }, 100)
        const promises = []

        if (!this.$utils.isEmpty(this.initialFilter)) {
          this.dont_fetch = true
          this.interaction_types = this.initialFilter?.types || []
          this.interaction_categories = this.initialFilter?.categories || []

          this.initialFilter?.companies?.forEach((company) => {
            if (company !== "this_record") {
              promises.push(this.$store.dispatch("data/getRecord", typeof company == "string" ? company : company.id))
            }
          })

          this.initialFilter?.contacts?.forEach((contact) => {
            promises.push(this.$store.dispatch("data/getRecord", typeof contact == "string" ? contact : contact.id))
          })
          if (this.initialFilter.collaborators?.length) {
            this.interaction_users = this.initialFilter.collaborators
          }

          if (this.initialFilter.types?.length) {
            this.interaction_types = this.$store.state.data.interaction_types
              .filter((t) => this.initialFilter.types?.includes(t.value))
              .map((t) => t.value)
          }
        }

        Promise.all(promises).then((values) => {
          const interaction_contacts_calc = []
          const interaction_companies_calc = []
          values.forEach((res_value) => {
            if (res_value.data.type == "contact") {
              interaction_contacts_calc.push(res_value.data)
            } else {
              interaction_companies_calc.push(res_value.data)
            }
          })

          if (interaction_companies_calc.length) {
            this.interaction_companies = interaction_companies_calc
          } else {
            this.interaction_companies = null
          }
          if (interaction_contacts_calc.length) {
            this.interaction_contacts = interaction_contacts_calc
          } else {
            this.interaction_contacts = null
          }
          let obj = {}
          this.interaction_filters.map((x) => {
            obj[Object.keys(x)] = Object.values(x)[0]
          })
          let params = {
            ...obj,
            ordering: this.ordering_query,
            page_size: page_size,
            expand: "record,contacts",
            ...(!!this.interaction_types?.length && {
              type: this.interaction_types.join(",")
            }),
            ...(!!this.interaction_categories?.length && {
              category: this.interaction_categories.join(",")
            }),
            ...(!!this.interaction_users && {
              users: this.interaction_users.join(",")
            }),
            ...(!!this.interaction_companies?.length && {
              records: this.interaction_companies.map((c) => c.id).join(",")
            }),
            ...(!!this.interaction_contacts && {
              contacts: this.interaction_contacts.map((c) => c.id).join(",")
            })
          }

          if (this.initialFilter?.relative_due_date) {
            params["relative_due_date"] = this.initialFilter.relative_due_date
          }
          if (this.interaction_due_date_range) {
            params["interaction_date_start"] = this.$moment(this.interaction_due_date_range.start).startOf("day").toISOString()
            params["interaction_date_end"] = this.$moment(this.interaction_due_date_range.end).endOf("day").toISOString()
          }
          params["prevent_loading"] = true
          if (!this.showNylasItemsGmail) {
            params["exclude_origin"] = "gmail"
          }
          if (!this.showNylasItemsOutlook) {
            params["exclude_origin"] = params?.exclude_origin ? "gmail,outlook" : "outlook"
          }

          if (!this.tied_record) {
            if (page == 1) {
              this.$store.dispatch("data/getInteractions", params).then((res) => {
                this.interactions = res.data
                this.dont_fetch = false
              })
            } else {
              this.loadMoreActions(page)
            }
          } else {
            let id = this.tied_record
            if (this.tied_record_full?.type == "contact") {
              params["contacts"] = id
            }
            if (page == 1) {
              this.$store
                .dispatch("data/getRecordInteractions", {
                  id: id,
                  params,
                  for_contact: this.tied_record_full?.type == "contact"
                })
                .then((res) => {
                  this.interactions = res.data
                  this.dont_fetch = false
                })
            } else {
              this.loadMoreActions(page)
            }
          }
        })
      }
    },
    getEmailActions(email) {
      const options_list = [
        {
          name: "Reply",
          action: () => {
            const i_service = this.$store.state.integration.integrations.find((i) => i.name == "gmail")
            if (i_service && i_service.scope.includes("https://www.googleapis.com/auth/gmail.modify")) {
              if (i_service.status == "on") {
                this.$emitter.emit(ALL_EMITTERS.SEND_EMAIL, {
                  records: [],
                  record: { ...email.meta_data.from[0], type: "team_members" },
                  content: email.description,
                  ref_record: email,
                  reply_id: email.meta_data.id,
                  thread_id: email.meta_data.thread_id
                })
              } else {
                this.$emitter.emit(ALL_EMITTERS.INTEGRATION_MISSING_MODAL, {
                  message: "Email integration is not active, Activate integration to send an email"
                })
              }
            } else {
              this.$emitter.emit(ALL_EMITTERS.INTEGRATION_MISSING_MODAL, {
                message: "In order to send an email please link your account to your Email."
              })
            }
          },
          icon: Reply
        }
      ]

      if (email.meta_data.to.length > 1 || email.meta_data?.cc?.length) {
        options_list.push({
          name: "Reply to All",
          action: () => {
            const i_service = this.$store.state.integration.integrations.find((i) => i.name == "gmail")
            if (i_service && i_service.scope.includes("https://www.googleapis.com/auth/gmail.modify")) {
              if (i_service.status == "on") {
                const all_emails = email.meta_data.to.concat(email.meta_data?.cc)
                const filtered_emails = all_emails.filter((email) => email.email !== this.$store.state.auth.user.email)
                const mapped_emails = filtered_emails.map((email) => {
                  return { ...email, type: "team_members" }
                })
                this.$emitter.emit(ALL_EMITTERS.SEND_EMAIL, {
                  cc_records: mapped_emails,
                  record: { ...email.meta_data.from[0], type: "team_members" },
                  content: email.description,
                  ref_record: email,
                  reply_id: email.meta_data.id,
                  thread_id: email.meta_data.thread_id
                })
              } else {
                this.$emitter.emit(ALL_EMITTERS.INTEGRATION_MISSING_MODAL, {
                  message: "Email integration is not active, Activate integration to send an email"
                })
              }
            } else {
              this.$emitter.emit(ALL_EMITTERS.INTEGRATION_MISSING_MODAL, {
                message: "In order to send an email please link your account to your Email."
              })
            }
          },
          icon: Reply
        })
      }

      options_list.push({
        name: "Forward",
        action: () => {
          const i_service = this.$store.state.integration.integrations.find((i) => i.name == "gmail")
          if (i_service && i_service.scope.includes("https://www.googleapis.com/auth/gmail.modify")) {
            if (i_service.status == "on") {
              this.$emitter.emit(ALL_EMITTERS.SEND_EMAIL, {
                records: [],
                content: email.description,
                ref_record: email
              })
            } else {
              this.$emitter.emit(ALL_EMITTERS.INTEGRATION_MISSING_MODAL, {
                message: "Email integration is not active, Activate integration to send an email"
              })
            }
          } else {
            this.$emitter.emit(ALL_EMITTERS.INTEGRATION_MISSING_MODAL, {
              message: "In order to send an email please link your account to your Email."
            })
          }
        },
        icon: Forward
      })

      return options_list
    }
  }
}
</script>
